/* eslint-disable react-hooks/exhaustive-deps */
import IconEdit from "@mui/icons-material/Edit";
import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchGenres, resetStateCommon } from "../../app/slices/commonSlice";
import AppDataTable from "../../components/appDataTable/appDataTable";
import EmptyDataContainer from "../../components/emptyDataContainer/emptyDataContainer";
import ErrorContainer from "../../components/errorContainer/errorContainer";
import LoadingContainer from "../../components/loadingContainer/loadingContainer";
import GenreDialog from "./GenreDialog";

const GenreList = () => {
  const {
    genres: { list, error, status },
  } = useSelector(({ common }) => common);
  const dispatch = useDispatch();
  const [genreList, setGenreList] = useState(null);
  const [selectedGenre, setSelectedGenre] = useState(null);
  const [open, setOpen] = useState(false);

  const _fetchListParams = (() => {
    let _params = {
      resource: "genres",
    };
    return _params;
  })();

  const columns = [
    {
      name: "TITLE",
      label: "Name",
    },
    {
      name: "QUANTITY",
      label: "No. of Items",
    },
    {
      name: "HAS_COVER",
      label: "Cover Image Uploaded",
    },
    {
      name: "STATUS_DISPLAY",
      label: "Status",
    },
  ];

  const translateStatus = (status) => {
    switch (status) {
      case "A":
        return "Active";
      case "I":
        return "Inactive";
      case "D":
        return "Disabled";
      default:
        return "N/A";
    }
  };

  useEffect(() => {
    dispatch(fetchGenres(_fetchListParams));
  }, []);

  useEffect(() => {
    if (list?.length > 0) {
      let _list = [];
      list.forEach((genre) => {
        _list.push({
          ...genre,
          STATUS_DISPLAY: translateStatus(genre.STATUS),
          HAS_COVER: genre.COVER_IMAGE?.includes("http") ? "Yes" : "No",
        });
      });
      setGenreList(_list);
    } else {
      setGenreList([]);
    }
  }, [list]);

  return (
    <>
      <div className="container-100 mb-20 "></div>
      <div className="flex-row">
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            setOpen(true);
          }}
        >
          Add Genre
        </Button>
      </div>

      {status === "loading" && (
        <LoadingContainer
          hasBackground={true}
          message="Loading genres"
          id="loading-container-genres"
        />
      )}

      {error !== null && status !== "loading" && (
        <ErrorContainer
          id="error-container-genres"
          hasBackground={true}
          message={error?.message || "An error occurred"}
          onReload={() => {
            dispatch(resetStateCommon());
            dispatch(fetchGenres(_fetchListParams));
          }}
        />
      )}

      {status === "idle" && list?.length <= 0 && (
        <EmptyDataContainer
          message="No genres found"
          hasBackground={true}
          id="empty-data-genres"
        />
      )}

      {genreList?.length > 0 && error === null && status === "idle" && (
        <AppDataTable
          id="genre-list"
          action={[
            {
              action: "Update",
              onClick: (item) => {
                setSelectedGenre(item);
                setOpen(true);
              },
            },
          ]}
          actionIcon={<IconEdit color="secondary" />}
          columns={columns}
          data={genreList}
          emptyMessage="No genres found"
          rowsPerPageOptions={[10, 20, 50, 100]}
          downloadFileName="System Genres"
        />
      )}

      {open && (
        <GenreDialog
          selectedGenre={selectedGenre}
          open={open}
          handleClose={() => {
            dispatch(fetchGenres(_fetchListParams));
            setSelectedGenre(null);
            setOpen(false);
          }}
        />
      )}
    </>
  );
};

export default GenreList;
